import React from "react";
import styles from "./map-navigation-control.module.scss";
import PropTypes from "prop-types";

function PlusIcon(props) {
    return (
        <svg
            width={12}
            height={12}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M11.5 5H7V.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V5H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H5v4.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V7h4.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"
                fill="#555"
            />
        </svg>
    );
}

function MinusIcon(props) {
    return (
        <svg
            width={12}
            height={2}
            viewBox="0 0 12 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M11.5 0H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"
                fill="#555"
            />
        </svg>
    );
}

const MapNavigationControl = ({ onZoomInClick, onZoomOutClick }) => {
    return (
        <div className={styles.navigationControl}>
            <div className="mapboxgl-ctrl mapboxgl-ctrl-group ">
                <button
                    className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in"
                    type="button"
                    title="Zoom In"
                    onClick={onZoomInClick}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    tabIndex={1}
                >
                    <PlusIcon />
                </button>
                <button
                    className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out"
                    type="button"
                    title="Zoom Out"
                    onClick={onZoomOutClick}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    tabIndex={1}
                >
                    <MinusIcon />
                </button>
            </div>
        </div>
    );
};

MapNavigationControl.propTypes = {
    onZoomInClick: PropTypes.func.isRequired,
    onZoomOutClick: PropTypes.func.isRequired,
};

export default MapNavigationControl;



// WEBPACK FOOTER //
// ./src/components/map/map-navigation-controls.js